import { keyframes, styled } from 'styled-components';

export const Wrapper = styled.div`
    width: 100%;
    min-height: 100%;
    height: 0; // For scroll behavior
    overflow-y: hidden;
    grid-column: 1 / span 1;

    display: grid;
    grid-template-rows: 1fr auto;
    align-items: center;

    scroll-behavior: smooth;
`;

export const Scrollable = styled.div`
    height: 100%;

    padding: 1rem;
    overflow-y: scroll;
`;

export const ChatInputWrapper = styled.div`
    width: 100%;
    padding: 1rem 1rem 1.5rem; // Add extra padding on the bottom for declaimer
`;

const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;
export const MessageInput = styled.div`
    max-width: var(--max-width);
    margin: auto;
    padding: 1rem;
    border: 1px solid var(--color-accent-blue);
    position: relative;

    font-size: 1.8em;

    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    border-radius: 1rem;

    align-items: center;

    background: var(--color-white);
    box-shadow: 0.25rem 0.25rem 0.25rem var(--color-accent-blue-20);

    animation: ${fadeIn} 0ms.8 ease forwards;

    & > textarea {
        width: 100%;
        resize: none;
        border: none;
        overflow: hidden;
        outline: none;
        caret-color: var(--color-primary);
        background: transparent;
        line-height: 1.3rem;
    }

    & > textarea:disabled {
        color: var(--color-disabled);
        background: transparent;
    }

    & > button {
        align-self: flex-end;
    }

    &:after {
        content: 'Denna tjänst drivs av AI och misstag kan förekomma.';
        position: absolute;
        bottom: 0;
        transform: translateY(calc(100% + 0.25rem));
        font-size: 0.7rem;
        color: var(--color-accent);
    }
`;

export const MessageThread = styled.div`
    width: 100%;
    max-width: var(--max-width);
    margin: auto;
    height: 100%;

    display: flex;
    flex-direction: column;
    gap: 1rem;
`;
